module.exports = __webpack_public_path__ + "static/media/icon-arrow-back.f9a44e1c.svg";